unit UTimeDataConfig;

interface

uses
  Js;

type
  TTimeDataConfig = class
  private
    FZeitartIds: string;
    procedure ClearValues;
    procedure SetValues(json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetZeitartIds(const Value: string);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    property ZeitartIds: string read FZeitartIds write SetZeitartIds;
  end;

implementation

{ TTimeDataConfig }

procedure TTimeDataConfig.ClearValues;
begin
  Self.ZeitartIds:='';
end;

constructor TTimeDataConfig.Create;
begin
  Self.ClearValues;
end;

constructor TTimeDataConfig.Create(json: string);
begin
  Self.SetValues(json);
end;

procedure TTimeDataConfig.SetValues(obj: TJsObject);
begin
  Self.ClearValues;
  if obj['ZeitartIds']<>nil then
    Self.ZeitartIds:=string(obj['ZeitartIds']);
end;

procedure TTimeDataConfig.SetValues(json: string);
var obj: TJsObject;
begin
  obj:=TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

procedure TTimeDataConfig.SetZeitartIds(const Value: string);
begin
  FZeitartIds := Value;
end;

end.
